import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { SuccessInsert } from '../components/SuccessInsert';
import { ConnectionInsert } from '../components/ConnectionInsert';
import { BundleSection } from '../components/BundleSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { EmpathySection } from '../components/EmpathySection';
import { DecisionSection } from '../components/DecisionSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-charcoal relative overflow-x-hidden" data-id="element-315">
      <AnnouncementBar data-id="element-316" />
      <HeroSection data-id="element-317" />
      <SocialProofSection data-id="element-318" />
      <SuccessInsert data-id="element-319" />
      <ConnectionInsert data-id="element-320" />
      <BundleSection data-id="element-321" />
      <OrderBumpSection data-id="element-322" />
      <TestimonialsSection data-id="element-323" />
      <EmpathySection data-id="element-324" />
      <DecisionSection data-id="element-325" />
      <FAQSection data-id="element-326" />
      <Footer data-id="element-327" />
      <StickyButton data-id="element-328" />
    </main>;
}